import React, { useState } from "react"
import { useFirestore } from "react-redux-firebase"
import {
  Button,
  Col,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Row,
} from "reactstrap"
import AddressList from "../AddressList/AddressList"
import AddressForm from "./AddressForm"

export default function UserAddress({
  addressList,
  auth,
  notify,
  onRadioChange,
}) {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)
  const firestore = useFirestore()
  const [addressId, setAddressId] = useState("")
  const deleteAddress = async (id) => {
    try {
      let customerRef = firestore.collection("customers").doc(auth.uid)
      await customerRef.collection("address").doc(id).delete()
      const message = "Address deleted successfully."
      notify("success", message, "Success")
    } catch (error) {
      console.log(`{error}`, { error })
      const message = error?.message || "Error while deleting address"
      notify("error", message, "Error")
    }
  }
  return (
    <Row form className="mb-3">
      <AddressForm
        modal={modal}
        toggle={toggle}
        auth={auth}
        notify={notify}
        addressId={addressId}
      />
      <Col md="12">
        <AddressList
          addressList={addressList}
          onRadioChange={onRadioChange}
          onDeleteClick={(addressId) => deleteAddress(addressId)}
          onEditClick={(addressId) => {
            setAddressId(addressId)
            toggle()
          }}
        />
      </Col>
      <Col col="12" style={{ margin: "20px 0" }}>
        <Button
          className="float-right"
          color="primary"
          onClick={() => {
            setAddressId("")
            toggle()
          }}
        >
          Add New Address
        </Button>
      </Col>
    </Row>
  )
}
